import { CompileFunction, CompileResult } from './types';

export * from './types';

// Webpack 5 native worker syntax
const worker = new Worker(new URL('./compile.worker.ts', import.meta.url));

let messageId = 0;
const pending = new Map<number, { resolve: (value: CompileResult) => void; reject: (error: Error) => void }>();

worker.onmessage = (event: MessageEvent<{ id: number; result?: CompileResult; error?: string }>) => {
  const { id, result, error } = event.data;
  const handler = pending.get(id);
  if (handler) {
    pending.delete(id);
    if (error) {
      handler.reject(new Error(error));
    } else if (result) {
      handler.resolve(result);
    }
  }
};

export const compile: CompileFunction = (args) => {
  return new Promise((resolve, reject) => {
    const id = messageId++;
    pending.set(id, { resolve, reject });
    worker.postMessage({ id, args });
  });
};
